import { IMacro } from "store/entities/macros/interfaces";

import { IMacroTemplate } from "./interfaces";

export const MacroTemplateStrings = {
  CURRENT_AGENT_ID: "<CURRENT_AGENT_ID>",
  DEFAULT_TEAM_ID: "<DEFAULT_TEAM_ID>",
};

export const isPrivateMacro = (macro: IMacro): boolean => (macro ? macro.agentId !== null : false);

export const isSharedMacro = (macro: IMacro): boolean => (macro ? macro.agentId === null : false);

export const filterMacrosAlphabeticallyInTicket = (macros: IMacro[], ticketAssignmentTeamId: string): IMacro[] =>
  macros
    ? macros
        .filter(macro => {
          if (macro.teamIds === null) {
            return true;
          }
          return macro.teamIds.includes(ticketAssignmentTeamId);
        })
        .sort((a, b) =>
          (a.name || "").localeCompare(b.name || "", undefined, {
            sensitivity: "base",
          })
        )
    : [];

export const replaceMacroTemplateStrings = (
  macro: Omit<IMacroTemplate, "icon">,
  currentAgentId: string | null,
  defaultTeamId: string
): Omit<IMacroTemplate, "icon"> => {
  return JSON.parse(
    JSON.stringify(macro)
      .replace(/<DEFAULT_TEAM_ID>/g, defaultTeamId)
      .replace(/<CURRENT_AGENT_ID>/g, currentAgentId ?? "")
  );
};
